module.exports = __webpack_public_path__ + "media/system/spinner-9836760e.svg";